module.exports = __webpack_public_path__ + "img/card-top.0209562b.svg";